module.exports = __webpack_public_path__ + "img/eh.eha4db87f.svg";